import { ObservableFromFetch } from "../ObservableFromFetch"
import PasswordSetModel from "./Model/PasswordSetModel"

export default function SetPassword(password: PasswordSetModel) {
    const requestBody = JSON.stringify(password)
    return ObservableFromFetch<string>("FFOrderClinicStatus/SetPassword", requestBody, 'put')
}